import { useEffect, useState } from "react";
import { extractYouTubeId } from "../../../global-components/src/utils/text";

interface Props{
    text?: string;
}

export const YoutubePreview = ({ text } : Props) => {
    const [youtubeId, setYoutubeId] = useState<string | null>(null);
    
    useEffect(() => {
        if(text){
            const videoId = extractYouTubeId(text);
            setYoutubeId(videoId);
        }
    }, [text])

    return (
        <>
            {youtubeId && (
                    <iframe
                        className="frame-youtube"
                        src={`https://www.youtube.com/embed/${youtubeId}`}
                        title="YouTube preview"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: 10 }}
                    />
                )}
        </>
    );
}